// extracted by mini-css-extract-plugin
export default {"loginContainer":"login_loginContainer__MvaDH","img":"login_img__DwJ1a"};